type UseHoursListPayload = {
  intervalMinutes?: number
  minTime?: string
  maxTime?: string
}

export function useHoursList(payload: UseHoursListPayload = {}) {
  const { minTime, maxTime, intervalMinutes = 15 } = payload

  let current = new Date()
  const end = new Date()
  const hours: string[] = []

  end.setDate(current.getDate() + 1)

  if (minTime && isTime(minTime)) {
    const [hours, minutes] = minTime.split(':')

    current.setHours(Number(hours))
    current.setMinutes(Number(minutes))
  } else {
    current.setHours(0)
    current.setMinutes(0)
  }

  if (maxTime && isTime(maxTime)) {
    const [hours, minutes] = maxTime.split(':')

    end.setDate(current.getDate())
    end.setHours(Number(hours))
    end.setMinutes(Number(minutes))
  } else {
    end.setHours(0)
    end.setMinutes(0)
  }

  while (current.getTime() < end.getTime()) {
    const hour = String(current.getHours()).padStart(2, '0')
    const mins = String(current.getMinutes()).padStart(2, '0')

    hours.push(`${hour}:${mins}`)

    current = new Date(current.getTime() + intervalMinutes * 60000)
  }

  return hours
}

function isTime(input?: string) {
  return input?.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)
}
